export default __webpack_public_path__ + "static/media/ALINA_HUZ--white.ca99ebf4.svg";